// extracted by mini-css-extract-plugin
module.exports = {"gwFooterMobile":"FooterMobile-hashed__gwFooterMobile__2XsIv","gwFooterMobileNonLinkItem":"FooterMobile-hashed__gwFooterMobileNonLinkItem__29xkH"};